import OnScreen from 'onscreen';

const $ = jQuery;
const $window = $(window);

const initServicesInfo = () => {
  const els = once('services-info', '.p-services-info');
  els.forEach((el) => {
    const $this = $(el);
    const $wrapper = $this.find('.psi-circle-wrapper');
    const $outerCircle = $this.find('.psi-items-circle-outer');
    const $circle = $this.find('.psi-items-circle');

    const circleAmt = $circle.children().length;
    let rotation = -90;

    $outerCircle.one(
      'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
      function () {
        $outerCircle.css('opacity', '1');
        $circle.css('opacity', '1');
      },
    );

    $circle
      .find('.psi-item-icon')
      .one(
        'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
        function () {
          $(this).css('opacity', '1');
        },
      );

    $circle.children().each(function (i) {
      const angle = (360 * i) / circleAmt;
      $(this).css('--axis-rotation', `${angle}deg`);

      $(this).on('click', function (e) {
        const currentId = $(this).attr('id');
        if (!$(this).children().hasClass('active')) {
          setActive(currentId);
          rotateCircle(
            minStepsToTop(
              getRotation('axis', $(this)),
              getRotation('circle', $(this)),
              circleAmt,
            ),
          );
        }
      });
    });

    const setActive = (serviceItem) => {
      $('.psi-item-icon').removeClass(
        'psi-item-circle-animation active psi-item-pop-animation',
      );
      $(`#${serviceItem}`).children().addClass('active');
      $(`#${serviceItem}`).children().addClass('psi-item-pop-animation');
      $('.psi-service-wrapper.active').fadeOut(250);
      $('.psi-service-wrapper.active').removeClass('active');
      $(`#${serviceItem}-card`).delay(300).fadeIn(300);
      $(`#${serviceItem}-card`).addClass('active');
    };

    const updateCircleRotation = (deg) => {
      $circle.css('--circle-rotation', `${deg}deg`);
    };

    const minStepsToTop = (aR, mR, aL) => {
      const totalSteps = Math.round(
        ((((mR + 360) % 360) + 90 + aR) * aL) / 360,
      );
      const maxAbsoluteSteps = Math.floor(aL / 2);
      return -(((totalSteps + maxAbsoluteSteps + aL) % aL) - maxAbsoluteSteps);
    };

    const getRotation = (type, target) => {
      return +target.css(`--${type}-rotation`).replace('deg', '');
    };

    const rotateCircle = (steps) => {
      rotation += (360 * steps) / circleAmt;
      updateCircleRotation(rotation);
    };

    // @todo
    // Trigger animations when the element enters the viewport.
    // Initialize OnScreen with a tolerance based on the wrapper height
    // to start animations when the element is half visible. The `debounce`
    // setting ensures animations only trigger once the element is fully in view.
    const os = new OnScreen({
      tolerance: $wrapper.height() / 2,
      debounce: 20,
    });

    let hasAnimated = false;
    os.on('enter', '.psi-circle-wrapper', function () {
      if (!hasAnimated) {
        $this
          .find('.psi-details-circle')
          .addClass('psi-inner-circle-animation');
        $this
          .find('.psi-items-circle-outer')
          .addClass('psi-outer-circle-scalein-animation');
        $this.find('.psi-items-circle').addClass('psi-outer-circle-animation');
        $this.find('.psi-item-icon').addClass('psi-item-circle-animation');
        hasAnimated = true;
        setTimeout(function () {
          // First child adjustments on animation end
          $('#spare-parts-supply').children().addClass('active');
          $('#spare-parts-supply')
            .children()
            .addClass('psi-item-pop-animation');
          $('#spare-parts-supply-card').addClass('active');
          $('#spare-parts-supply-card').fadeIn(600);
        }, 2500);
      }
    });
  });
};

$window.on('load', () => initServicesInfo());
